<div class="sup-page">

  <div class="sup-page-header">
    <div>
      <div class="sup-page-title">Agent Wallboard</div>
      <div class="sup-page-sub">Real-time availability plus selected date-range call-log performance</div>
    </div>
    <div class="sup-page-actions">
      <input class="sup-date-input" type="date" [(ngModel)]="fromDate" (change)="fetchPerformance()" />
      <input class="sup-date-input" type="date" [(ngModel)]="toDate" (change)="fetchPerformance()" />
      <button class="sup-btn btn-primary" (click)="downloadCsv()">
        <span class="material-icons">download</span>CSV
      </button>
      <span class="sup-badge sb-green">
        <span class="sup-live-dot"></span>Live
      </span>
    </div>
  </div>

  <div class="sup-stats-grid">
    <div *ngFor="let s of stats" class="sup-stat-card" [ngClass]="'sc-'+s.col">
      <div class="sup-stat-label">{{s.label}}</div>
      <div class="sup-stat-value">{{s.val}}</div>
    </div>
  </div>

  <div class="sup-card">
    <div class="sup-card-header">
      <span class="sup-card-title">
        <span class="material-icons">bar_chart</span>Agent Performance Table
      </span>
      <span class="sup-badge sb-blue">{{agents.length}} Agents</span>
    </div>
    <div style="overflow-x:auto">
      <table class="sup-tbl">
        <thead>
          <tr>
            <th>Agent</th>
            <th title="Operational category for this row, such as agent calls or live-agent handoff attempts.">Task</th>
            <th>Ext</th>
            <th>Status</th>
            <th>Current Call</th>
            <th title="Total calls received/offered in this row for the selected date range.">Total Calls</th>
            <th title="Calls successfully answered and completed by an agent.">Handled</th>
            <th title="Calls offered to a specific agent but not answered by that agent.">Missed</th>
            <th title="Calls that entered the live-agent flow but were not assigned to any agent.">Unrouted</th>
            <th title="Average handling time for answered/completed calls only.">Avg Handle</th>
            <th title="Average hold time recorded for answered/completed calls.">Avg Hold</th>
            <th title="First Call Resolution percentage for handled calls.">FCR %</th>
            <th title="Calls where callback was required.">Callbacks</th>
            <th title="Percentage of handled calls where wrap-up notes were completed.">Wrap-up</th>
            <th title="Shows whether this row is within configured target handle time, or highlights risk/unrouted calls.">Timeline</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let a of agents">
            <td>
              <div style="display:flex;align-items:center;gap:8px">
                <div class="sup-avatar"
                     style="width:28px;height:28px;font-size:11px"
                     [style.background]="'linear-gradient(135deg,' + a.gradFrom + ',' + a.gradTo + ')'">
                  {{a.initials}}
                </div>
                <span style="font-weight:600">{{a.name}}</span>
              </div>
            </td>
            <td class="td2" [title]="a.task === 'Live-agent handoff' ? 'Citizen selected live-agent flow from IVR.' : 'Calls associated with this agent extension.'">{{a.task}}</td>
            <td class="td-mono">{{a.ext}}</td>
            <td>
              <span class="sup-badge" [ngClass]="agentBadge(a.status)"
                    [title]="a.status === 'Unrouted' ? 'Call entered the live-agent flow but no agent was assigned.' : 'Current live extension state.'">
                {{a.status}}
              </span>
            </td>
            <td class="td2">{{a.status === 'On Call' ? a.callTime : '-'}}</td>
            <td style="font-weight:700" title="Total calls received/offered in this row.">{{a.totalCalls}}</td>
            <td style="font-weight:700">{{a.handled}}</td>
            <td style="font-weight:700" title="Assigned to an agent but not answered.">{{a.missed}}</td>
            <td style="font-weight:700" title="Entered live-agent flow but no agent was assigned.">{{a.unrouted}}</td>
            <td class="td2">{{a.avg}}</td>
            <td class="td2">{{a.avgHold}}</td>
            <td style="font-weight:600" [style.color]="fcrColor(a.fcr)">{{a.fcr}}</td>
            <td style="font-weight:700">{{a.callbacks}}</td>
            <td style="font-weight:600" [style.color]="wrapUpColor(a.wrapUp)">{{a.wrapUp}}</td>
            <td>
              <span class="sup-badge" [ngClass]="a.slaOk ? 'sb-green' : 'sb-red'">
                <span class="material-icons" style="font-size:11px">{{ a.slaOk ? 'check_circle' : 'warning' }}</span>
                {{ a.slaOk ? 'OK' : 'Risk' }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
